import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LangProvider } from '@/i18n/LangContext';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import ServicesSection from '@/components/ServicesSection';
import ProductsSection from '@/components/ProductsSection';
import WhyChooseUs from '@/components/WhyChooseUs';
import BlogSection from '@/components/BlogSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import AdminPanel from '@/components/AdminPanel';

function HomePage() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProductsSection />
        <WhyChooseUs />
        <BlogSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}

function AdminRoute() {
  const path = window.location.pathname;
  const match = path.match(/\/admin(\d{6})/);
  if (!match) return <Navigate to="/" replace />;
  const code = match[1];
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yy = String(now.getFullYear()).slice(-2);
  const todayCode = `${dd}${mm}${yy}`;
  if (code !== todayCode) return <Navigate to="/" replace />;
  return <AdminPanel />;
}

function CatchAll() {
  const path = window.location.pathname;
  if (path.startsWith('/admin')) return <AdminRoute />;
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <LangProvider>
      <div className="App" data-testid="app-root">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<CatchAll />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LangProvider>
  );
}

export default App;
